/* eslint-disable @typescript-eslint/camelcase */

const iceConfiguration = {
  iceServers: [
    {
      // urls: 'stun:building-cpbae.nccu.edu.tw:3478'
      urls: 'stun:cpbae-gate-aws-01.nccu.edu.tw:3478'
    },
    {
      // urls: 'stun:building-cpbae.nccu.edu.tw:3478'
      urls: 'turn:cpbae-gate-aws-01.nccu.edu.tw:3478',
      username: 'turnuser',
      credential: 'turnpassword'
    }
    // {
    //   urls: 'stun:honeypot.tih.tw:3478'
    // }
  ]
}

export const Client = function (param) {
  console.log(param)

  const callsEndpoint = 'https://building-cpbae.nccu.edu.tw/1/calls'

  const mediaType = {
    audio: {
      autoGainControl: true
    }
    // ,
    // video: true
  }

  const eventSource = new EventSource(callsEndpoint + '?event-stream&from=callee')

  this.pc = new RTCPeerConnection(iceConfiguration)
  const updateStatus = param.updateStatus
  const show = param.show
  const showService = param.showService
  const hangup = param.hangup
  let connectingRoomID

  let localView = param.localVideo
  let remoteView = param.remoteVideo

  const modifyGain = (stream, gainValue) => {
    const ctx = new AudioContext()
    const src = ctx.createMediaStreamSource(stream)
    const dst = ctx.createMediaStreamDestination()
    const gainNode = ctx.createGain()
    gainNode.gain.value = gainValue
    src.connect(gainNode)
    gainNode.connect(dst)
    return dst.stream
  }

  const applyAnalyzer = (stream) => {
    const audioContext = new AudioContext()
    const analyser = audioContext.createAnalyser()
    const microphone = audioContext.createMediaStreamSource(stream)
    const javascriptNode = audioContext.createScriptProcessor(2048, 1, 1)

    analyser.smoothingTimeConstant = 0.3
    analyser.fftSize = 1024

    microphone.connect(analyser)
    analyser.connect(javascriptNode)
    javascriptNode.connect(audioContext.destination)

    // canvasContext = $("#canvas")[0].getContext("2d");
    let canvasContext = document.getElementById("microphone-test")
    window.canvasContext = canvasContext
    canvasContext = canvasContext.getContext("2d")

    javascriptNode.onaudioprocess = function () {
      const array = new Uint8Array(analyser.frequencyBinCount)
      analyser.getByteFrequencyData(array)
      let values = 0

      const length = array.length
      for (let i = 0; i < length; i++) {
        values += array[i]
      }

      const average = values / length
      canvasContext.clearRect(0, 0, 60, 130)
      canvasContext.fillStyle = '#00ff00'
      canvasContext.fillRect(0, 130 - average, 25, 130)
    }
  }

  const closeTracks = () => {
    const stream = window.localStream
    if (typeof streams === 'undefined') {
      return
    }
    stream.getTracks().forEach((t) => {
      console.log('track.readyState:', t.readyState)
      if (t.readyState === 'live') {
        t.stop()
      }
    })
  }

  const addICECandidateList = (list) => {
    list.forEach((candidate) => {
      this.pc.addIceCandidate(candidate)
        .then((_) => {
          console.log('addIceCandidate success')
        })
        .catch((err) => {
          console.log('addIceCandidate error:', err)
          console.log('unsupported cand:', candidate)
        })
    })
  }

  const setPeerConnectionOnIceCandidate = (pc) => {
    pc.onicecandidate = (e) => {
      console.log('onicecandidate', e)
      // Send candidat
      const body = new URLSearchParams({
        action: 'update-candidate',
        from: 'callee',
        candidate: JSON.stringify(e.candidate)
      })

      fetch(callsEndpoint, {
        method: 'POST',
        header: {
          'Content-Type': 'application/x-www-urlencoded'
        },
        body: body
      })
    }

    pc.oniceconnectionstatechange = (e) => {
      console.log('oniceconnectionstatechange:', e)
      console.log('state:', pc.iceConnectionState)
    }

    pc.onconnectionstatechange = (e) => {
      console.log('connectionState:', pc.connectionState, e)
      updateStatus(connectingRoomID, connectingRoomID + ' ' + pc.connectionState)
      switch (pc.connectionState) {
        case 'connected':
          // The connection has become fully connected
          updateStatus(connectingRoomID, '來自' + connectingRoomID + '的通話已接通，您可以說話了。 (' + pc.connectionState + ')')
          break
        case 'disconnected':
          break
        case 'failed':
          // One or more transports has terminated unexpectedly or in an error
          break
        case 'closed':
          // The connection has been closed
          break
      }
    }
    pc.onicecandidateerror = (e) => {
      console.log('onicecandidateerror:', pc.connectionState, e)
    }
  }
  let iStream = null
  const setPeerConnectionOnTrack = (pc) => {
    pc.ontrack = (e) => {
      remoteView = document.getElementById('remote-video')
      console.log('ontrack', e)
      if (e.streams && e.streams[0]) {
        remoteView.srcObject = e.streams[0]
      } else {
        if (!iStream) {
          iStream = new MediaStream()
          remoteView.srcObject = iStream
        }
        iStream.addTrack(e.track)
      }
      // for (const track of e.streams.getTracks()) {
      //     pc.addTrack(track)
      // }
    }
  }

  setPeerConnectionOnTrack(this.pc)
  setPeerConnectionOnIceCandidate(this.pc)
  const startCalleeVideo = () => {
    console.log('startCalleeVideo')
    updateStatus(connectingRoomID, '接聽來自' + connectingRoomID + '的呼叫中')
    navigator.mediaDevices.getUserMedia(mediaType)
      .then((stream) => {
        updateStatus(connectingRoomID, '接聽來自' + connectingRoomID + '的呼叫中，已取得音訊權限')
        window.localStream = stream
        // stream = modifyGain(stream, 2) // Cancel microphone gain
        console.log('getUserMedia:', stream)
        applyAnalyzer(stream)
        localView = document.getElementById('local-video')
        localView.srcObject = stream
        for (const track of stream.getTracks()) {
          console.log("get track", track)
          this.pc.addTrack(track)
        }
        this.pc.createAnswer()
          .then((answer) => {
            updateStatus(connectingRoomID, '傳送回應給' + connectingRoomID + '的呼叫中')
            console.log('createAnswer', answer)
            this.pc.setLocalDescription(answer)

            const data = {
              action: 'send-answer',
              from: 'callee',
              answer: JSON.stringify(answer)
            }
            const RoomIDKey = 'room_id'
            data[RoomIDKey] = connectingRoomID

            const body = new URLSearchParams(data)
            console.log('data', data)
            setTimeout(() => {
              fetch(callsEndpoint, {
                method: 'POST',
                header: {
                  'Content-Type': 'application/x-www-urlencoded'
                },
                body: body
              })
            }, 100)

            setTimeout(() => {
              addICECandidateList(window.enabledCandidate)
            }, 400)
          })
      })
  }
  eventSource.onmessage = (m) => {
    console.log('channel onmessage', m)
    const data = JSON.parse(m.data)
    console.log('data', data)
    if (data === null) {
      return
    }
    if (typeof data.candidate !== 'undefined') {
      // got candidate information
      console.log('got candidate information', data)
      const candidate = JSON.parse(data.candidate)
      const candidateString = candidate.candidate
      if (typeof window.recvedCandidate === 'undefined') {
        window.recvedCandidate = []
        window.enabledCandidate = []
      }
      window.recvedCandidate.push(data.candidate)
      console.log('candidateString:', candidateString)

      // if (candidateString.includes("relay")) {
      //   // Skip
      //   console.log('SKIP candidate')
      //   return
      // }
      // if (candidateString.includes("127.0.0.1")) {
      //   // Skip
      //   console.log('SKIP candidate')
      //   return
      // }
      // if (candidateString.includes("2600")) {
      //   // Skip
      //   console.log('SKIP candidate')
      //   return
      // }
      // if (candidateString.includes("::1")) {
      //   // Skip
      //   console.log('SKIP candidate')
      //   return
      // }
      // if (candidateString.includes("192.168")) {
      //   // Skip
      //   console.log('SKIP candidate')
      //   return
      // }
      const newCandidate = new RTCIceCandidate(candidate)
      window.enabledCandidate.push(newCandidate)
      console.log('newCandidate', newCandidate)

      // this.pc.addIceCandidate(newCandidate)
      //   .then((_) => {
      //     console.log('addIceCandidate success')
      //   })
      //   .catch((err) => {
      //     console.log('addIceCandidate error:', err)
      //     console.log('unsupported cand:', candidate)
      //   })
    } else if (typeof data.offer !== 'undefined') {
      // got offer
      console.log('offer:', data.offer)
      const offer = JSON.parse(data.offer)
      const rID = data.room_id

      show(rID, offer)

      // if (confirm('Do you want to answer: ' + rID)) {
      //   connectingRoomID = rID
      //   this.pc.setRemoteDescription(new RTCSessionDescription(offer))
      //   startCalleeVideo()
      // }
    } else if (typeof data.service_type_id !== 'undefined') {
      console.log('service type:', data.service_type_id)
      const rID = data.room_id
      showService(rID, data.service_type_id)
    } else if (typeof data.action !== 'undefined') {
      if (data.action === 'hang-up') {
        const rID = data.room_id
        this.close()
        closeTracks()
        hangup(rID)
      }
    }
  }

  this.answer = (roomID, offer) => {
    console.log('answering', roomID, offer)
    connectingRoomID = roomID
    this.pc.setRemoteDescription(new RTCSessionDescription(offer))
    startCalleeVideo()
  }

  this.close = () => {
    console.log(this)
    console.log(this.pc)
    closeTracks()
    try {
      this.pc.close()
      this.pc = new RTCPeerConnection(iceConfiguration)
      setPeerConnectionOnTrack(this.pc)
      setPeerConnectionOnIceCandidate(this.pc)
    } catch (error) {
      console.error(error)
    }
  }
  this.hangup = () => {
    const data = {
      action: 'hang-up',
      room_id: connectingRoomID
    }

    const body = new URLSearchParams(data)
    console.log('data', data)

    fetch(callsEndpoint, {
      method: 'POST',
      header: {
        'Content-Type': 'application/x-www-urlencoded'
      },
      body: body
    })
  }
}
